import { render } from "./EditUtenteForm.vue?vue&type=template&id=07ab8e10&scoped=true"
import script from "./EditUtenteForm.vue?vue&type=script&lang=js"
export * from "./EditUtenteForm.vue?vue&type=script&lang=js"

import "./EditUtenteForm.vue?vue&type=style&index=0&id=07ab8e10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07ab8e10"]])

export default __exports__